export default function initAccordion() {
  Alpine.data('accordion', (defaultOpen?) => ({
    opened: defaultOpen ?? '0',
    toggleOpen(id: string) {
      const content = document.getElementById(`accordion-content-${id}`);
      this.opened = (this.opened === id) ? '0' : id;

      if (content && content.classList.contains('max-h-0!')) {
        content.style.maxHeight = `${content.scrollHeight}px`;
      }
    },
    isOpened(id: string) {
      return this.opened === id;
    },
  }));
}
